// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"s7-z"};